import Scroll from "./scroll";
import { easeInOutCubic } from "./easing";
var Campo = /** @class */ (function () {
    function Campo(input, etiqueta) {
        this.input = input;
        this.etiqueta = etiqueta;
    }
    return Campo;
}());
var buscaCampoDeEtiqueta = function (etiqueta) {
    var atributoFor = etiqueta.getAttribute('for');
    if (atributoFor) {
        return document.getElementById(atributoFor);
    }
    return null;
}, configuraEtiquetas = function (formulario) {
    var campos = {}, etiquetas = formulario.querySelectorAll("p:not(.campo--checkbox) label");
    [].forEach.call(etiquetas, function (etiqueta) {
        var input = buscaCampoDeEtiqueta(etiqueta);
        if (input) {
            var padre = input.parentNode;
            if (padre) {
                var campo = new Campo(input, etiqueta.cloneNode(true));
                campos[input.id] = campo;
                padre.appendChild(campo.etiqueta);
            }
        }
    });
    formulario.addEventListener('blur', function (e) {
        var _a;
        var input = e.target, campo = campos[input.id];
        if (campo && !((_a = campo.input.value) === null || _a === void 0 ? void 0 : _a.trim()) && !campo.input.classList.contains('con-archivo')) {
            campo.etiqueta.classList.add('is-inactiva');
            if (campo.input.getAttribute('type') === 'date') {
                campo.input.style.color = 'transparent';
            }
        }
    }, true);
    formulario.addEventListener('focus', function (e) {
        var input = e.target, campo = campos[input.id];
        if (campo) {
            campo.etiqueta.classList.remove('is-inactiva');
            if (campo.input.getAttribute('type') === 'date') {
                campo.input.style.color = 'currentColor';
            }
        }
    }, true);
    return campos;
}, reinicia = function (campos) {
    Object.keys(campos).forEach(function (key) {
        var _a = campos[key], input = _a.input, etiqueta = _a.etiqueta;
        if (!input.value || input.value.trim() === '') {
            etiqueta.classList.add('is-inactiva');
        }
        if (input.getAttribute('type') === 'date') {
            input.style.color = 'transparent';
        }
    });
}, configuraSubmit = function (formulario, dataLayer, offset) {
    var submit = formulario.querySelector('[type="submit"]');
    formulario.addEventListener('submit', function (e) {
        e.preventDefault();
        submit.disabled = true;
        fetch(formulario.getAttribute('action'), {
            method: 'post',
            body: new FormData(formulario)
        })
            .then(function (x) { return x.text(); })
            .then(function (text) { return (new DOMParser()).parseFromString(text, 'text/html'); })
            .then(function (dom) {
            var f = dom.getElementById(formulario.getAttribute('id'));
            if (f) {
                formulario.innerHTML = f.outerHTML;
            }
            var scroll = new Scroll(easeInOutCubic);
            scroll.scrollTo(formulario.getBoundingClientRect().top + pageYOffset - offset, 300);
            if (!formulario.querySelector('input') && dataLayer) {
                dataLayer.push({
                    event: 'formulario-enviado',
                    formulario: formulario.id
                });
            }
        })
            .finally(function () { return submit.disabled = false; });
    });
}, configuraArchivos = function (campos) {
    Object.keys(campos)
        .filter(function (clave) { return campos[clave].input.type === 'file'; })
        .map(function (x) { return campos[x]; })
        .forEach(function (archivo) {
        var input = archivo.input, etiqueta = archivo.etiqueta, campo = input.closest('.campo');
        if (campo) {
            var texto_1 = document.createElement('div');
            texto_1.innerHTML = '&nbsp;';
            campo.appendChild(texto_1);
            campo.addEventListener('drop', function (ev) {
                var _a;
                ev.preventDefault();
                if ((_a = ev.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) {
                    input.files = ev.dataTransfer.files;
                    campo.classList.add('con-archivo');
                    texto_1.textContent = input.files[0].name;
                    etiqueta.classList.remove('is-inactiva');
                }
            });
            campo.addEventListener('dragover', function (e) {
                campo.classList.add('archivo-encima');
                e.preventDefault();
            });
            campo.addEventListener('dragleave', function (e) {
                campo.classList.remove('archivo-encima');
            });
            input.addEventListener('change', function (e) {
                var nombre = input.value.split('\\').pop();
                if (nombre) {
                    texto_1.textContent = nombre;
                }
            });
        }
    });
};
export default function formulario(selector, dataLayer, offset) {
    if (offset === void 0) { offset = 0; }
    [].forEach.call(document.querySelectorAll(selector), function (formulario) {
        formulario.classList.add('inicializado');
        var campos = configuraEtiquetas(formulario);
        configuraSubmit(formulario, dataLayer, offset);
        configuraArchivos(campos);
        reinicia(campos);
    });
}
